export default "__VITE_ASSET__d7976e6d__"